/**
 * Contract-month column headers (W-M14).
 *
 * The API labels the twelve contract months M1–M12 and sends the calendar month separately as
 * "Jun-25". Users read months, not contract indexes, so the column shows "Jun 2025". The M-label
 * stays in the API and the CSV export (it is what downstream sheets key on); only the screen
 * changes. Without a start date the API has no calendar month, so "Month 1" is the fallback.
 */
export interface MonthHeader {
  label: string;
  dateRange: string;
}

const SHORT_MONTH = /^([A-Za-z]{3})-(\d{2})$/;

export function monthHeaderText(month: MonthHeader | undefined, index: number): string {
  const range = month?.dateRange?.trim();
  if (range) {
    const m = SHORT_MONTH.exec(range);
    if (m) return `${m[1].charAt(0).toUpperCase()}${m[1].slice(1).toLowerCase()} 20${m[2]}`;
    return range;
  }
  const label = month?.label ?? '';
  const n = /^M(\d{1,2})$/.exec(label);
  return n ? `Month ${n[1]}` : label || `Month ${index + 1}`;
}

/** Placeholder headers before a report has run. */
export const PLACEHOLDER_MONTH_HEADERS: MonthHeader[] = Array.from({ length: 12 }, (_, i) => ({
  label: `M${i + 1}`,
  dateRange: '',
}));
